var XPortal = XPortal || {};
XPortal.EntityDetailBlock = (function () {
    //provide a way to show detail form directly on grid page or any other page
    var self =
    {
        Init: function (cntr) {
            cntr = $(cntr ? cntr : "body");
            cntr.find(".detailblock-viewcontainer").each(function () {
                InitFor(this);
            });
        },
        onRequestEnd: function (e, r, c, o) {
            showSelectionContainer(c, o, false);
        },
        showSelection: function (c, o, di, diId) {
            showSelectionContainer(c, o, true);
            if (c.attr("data-pid") == diId) return;
            c.attr("data-pid", diId);

            c.find(".detail-rel-parentinfo").each(function () {
                var $x = $(this);
                if ($x.closest(".detailblock-viewcontainer")[0] === c[0]) {//in case when we have deep structure - only first level children should be setup
                    $x.val(c.attr("data-src-id") + "#|#" + diId);
                    //$x.trigger("modified");
                    o.emptySControl.find("form").submit();
                }
            });
        },
        getOptions: function (c) {
            var ostr = c.attr("data-opts");
            var o = ostr && ostr.length ? eval("ostr=" + ostr) : {};
            o.SourceControl = $(c.attr("data-src"));
            o.emptySControl = c.children(".empty-selection");
            o.form_SControl = c.children(".selection-frm");
            o.block_header = c.siblings(".block-header_entity-detail");
            return o;
        }
    };

    function InitFor(cnrol) {
        cnrol = cnrol ? $(cnrol) : false;
        if (!(cnrol) || cnrol.length < 1) return;
        if (cnrol.attr("data-processed") == "1") return;
        cnrol.attr("data-processed", "1");

        var doptions = self.getOptions(cnrol);
        if (doptions.SourceControl.length > 0) {
            var onRequestEnd = function (e, r) {
                self.onRequestEnd(e, r, cnrol, doptions);
            };
            doptions.SourceControl.on("grid.requestEnd", onRequestEnd);
            var i = 1000;
            waitFor(function () {
                var kdata = doptions.SourceControl.data("kendoGrid");
                if (!kdata && i-- > -1) return false;
                if (i < 0) return true;
                const updateSelected = function (e) {
                    var sel = this.dataItem(this.select());
                    var selId = sel ? sel.UniqueId : "";
                    if (!selId) return;
                    self.showSelection(cnrol, doptions, sel, selId);
                };
                kdata.bind("parent.changed.updateSelected", updateSelected);
                if (kdata.dataSource.iRequestEnd && !doptions.isinitialized) onRequestEnd(null, kdata.dataSource.iRequestEnd);//when grid already with data,but we not processed this data yet
                return true;
            }, waitFor);
        }
        showSelectionContainer(cnrol, doptions);
    }
    function showSelectionContainer(c, o, isshow) {
        o.emptySControl.removeClass(isshow ? "d-flex" : "d-none");
        o.form_SControl.removeClass(isshow ? "d-none" : "d-flex");
        o.block_header.removeClass(isshow ? "d-none" : "d-flex");
        o.form_SControl.addClass(isshow ? "d-flex" : "d-none");
        o.emptySControl.addClass(isshow ? "d-none" : "d-flex");
        o.block_header.addClass(isshow ? "d-flex" : "d-none");
        c.removeClass(isshow ? "h-100" : "");
        c.addClass(isshow ? "" : "h-100");
    }
    function waitFor(onAction, onFalse) {
        if (!onAction()) setTimeout(function () { onFalse(onAction, onFalse); }, 100);
    }

    return self;
}());